import { constants, Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import moment from 'moment'
import * as ValidationRegex from 'src/common/NBCIValidationRegex.js'
import NBCIUSInvoiceKeys from 'src/constants/locale/key/NbciUsInvoice.js'

const {
  locale: {
    key: { CommonValidationMessageKeys }
  }
} = constants

function makeValidationSchema(translate) {
  const dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  const faxParrter = '^[0-9\\-\\+\\(\\)\\ ]+$'
  let errFaxPattern = translate(
    Namespace.NBCI_US_INVOICE,
    NBCIUSInvoiceKeys.Validations.ERR_MSG_ALPHA_NUMERIC_SPEC_CHAR_FAX
  )
  // const errFaxPattern = 'Please enter valid Fax'
  const regexAlphaNumeric =
    ValidationRegex.regexAlphaNumeric
  let errMsgAlphaNumeric = translate(
    Namespace.NBCI_US_INVOICE,
    NBCIUSInvoiceKeys.Validations.ERR_MSG_ALPHA_NUMERIC_SPEC_CHAR
  )
  // const errMsgAlphaNumeric =
  //   'Allowed special characters are  ' + ValidationRegex.errMsgAlphaNumeric
  const phonePattern = '^[0-9 -]*$'
  let phoneErrorMessage = translate(
    Namespace.NBCI_US_INVOICE,
    NBCIUSInvoiceKeys.Validations.ERR_MSG_NUMERIC_HYPHEN_SPACE
  )
  // const phoneErrorMessage =
  //   'Please enter valid phone number[digits with space or -]'

  return Yup.object({
    blanketPeriodFrom: Yup.mixed()
    .nullable()
    .default(null)
    .test('is-date', 'Invalid date format', (value) => {
      if (value === null || value === '') {
        return true // Allow null or empty fields
      }
      return moment(value, 'YYYY-MM-DD', true).isValid()
    }),
    blanketPeriodTo: Yup.mixed()
    .nullable()
    .default(null)
    .test('is-date', 'Invalid date format', (value) => {
      if (value === null || value === '') {
        return true // Allow null or empty fields
      }
      return moment(value, 'YYYY-MM-DD', true).isValid()
    }),
    company: Yup.string()
      .nullable()
      .max(100, 'Max value allowed is 100')
      .matches(regexAlphaNumeric, errMsgAlphaNumeric),
    title: Yup.string()
      .nullable()
      .max(50, 'Max value allowed is 50')
      .matches(regexAlphaNumeric, errMsgAlphaNumeric),
    naftaDate: Yup.mixed()
    .nullable()
    .default(null)
    .test('is-date', 'Invalid date format', (value) => {
      if (value === null || value === '') {
        return true // Allow null or empty fields
      }
      return moment(value, 'YYYY-MM-DD', true).isValid()
    }),
    naftapartyName: Yup.string()
      .nullable()
      .max(60, 'Max value allowed is 60')
      .matches(regexAlphaNumeric, errMsgAlphaNumeric),
    contactTelNum: Yup.string()
      .nullable()
      .matches(phonePattern, phoneErrorMessage)
      .max(30, 'Max length allowed is 30'),
    contactFax: Yup.string()
      .nullable()
      .matches(faxParrter, errFaxPattern)
      .max(35, 'Max length allowed is 35'),
    email: Yup.string()
      .nullable()
      .max(50, 'Max length allowed is 50')
      .email('Invalid email')
      .matches('[A-Za-z0-9+_.-]+@(.+)$', 'Enter Email in valid pattern'),
    cerifierType: Yup.string().nullable()
  })
}

export default makeValidationSchema
